import type { CityConfig } from "../city-template/types";

export const bartlesvilleConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Oklahoma State Dept of Health Vital Records", href: "https://oklahoma.gov/health/vital-records.html", description: "Official Oklahoma vital records office in Oklahoma City" },
    { label: "Marriage Licenses — Washington County Court Clerk", href: "https://www.countycourthouse.org/", description: "Washington County Court Clerk — marriage license issuance" },
    { label: "Divorce Records — Washington County Court Clerk", href: "https://www.countycourthouse.org/", description: "Washington County Court Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of OK DOH for online vital record orders" },
  ],
  city: "Bartlesville",
  state: "Oklahoma",
  stateAbbr: "OK",
  slug: "bartlesville",
  route: "/bartlesville",
  title: "Emergency Passport Bartlesville, OK | Expedited Passport Services | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Bartlesville, OK — as fast as 24 hours. Serving Phillips 66 professionals and Northeast Oklahoma. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Bartlesville, OK",
  heroSubtitle: "International business trip to London with Phillips 66 and your passport expired? Osage Hills weekend trip to Canada for hiking need fast documents? Last-minute vacation to Europe from Green Country with no valid passport? We help Bartlesville professionals and Northeast Oklahoma residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Bartlesville%20Oklahoma%20Price%20Tower%20Frank%20Lloyd%20Wright%20skyscraper%20iconic%20copper-green%20design%20downtown%20historic%20buildings%20Osage%20Hills%20state%20park%20rolling%20green%20hills%20in%20background%20Caney%20River%20winding%20through%20city%20Phillips%2066%20campus%20golden%20afternoon%20light%20professional%20drone%20photography&width=1800&height=700&seq=bartlesville-ok-hero-2026&orientation=landscape",
  heroImageAlt: "Bartlesville Oklahoma Price Tower Frank Lloyd Wright skyscraper with Osage Hills in background",
  geoPosition: "36.7503;-95.9808",
  geoPlacename: "Bartlesville, Oklahoma",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Dallas Passport Agency",
    address: "1100 Commerce Street, Suite 900, Dallas, TX 75242",
    distance: "Located in downtown Dallas — approximately 310 miles south of Bartlesville via US-75",
  },
  nearbyCitiesZips: [
    { name: "Bartlesville", zips: "74003, 74004, 74006" },
    { name: "Dewey", zips: "74029" },
    { name: "Copan", zips: "74022" },
    { name: "Nowata", zips: "74048" },
    { name: "Pawhuska", zips: "74056" },
    { name: "Caney, KS", zips: "67333" },
    { name: "Independence, KS", zips: "67301" },
    { name: "Coffeyville, KS", zips: "67337" },
    { name: "Owasso", zips: "74055" },
    { name: "Claremore", zips: "74017" },
    { name: "Skiatook", zips: "74070" },
    { name: "Collinsville", zips: "74021" },
    { name: "Ramona", zips: "74061" },
    { name: "Ochelata", zips: "74051" },
    { name: "Barnsdall", zips: "74002" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Phillips 66 and Northeast Oklahoma departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Osage Hills & Green Country", desc: "Serving Bartlesville, Dewey, Pawhuska, Nowata, and Northeast Oklahoma" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Tulsa, OK", route: "/tulsa" },
    { name: "Fast passport renewal in Oklahoma City, OK", route: "/oklahoma-city" },
    { name: "Emergency passport help in Broken Arrow, OK", route: "/broken-arrow" },
    { name: "Urgent passport services in Edmond, OK", route: "/edmond" },
    { name: "Same-day passport help in Dallas, TX", route: "/dallas" },
    { name: "Passport courier services in Wichita, KS area", route: "/kansas" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Bartlesville remotely via secure courier. We do not have a walk-in office in Bartlesville — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Washington County and Northeast Oklahoma.",
  fpcOfficeAddress: "1200 Main St, Kansas City, Missouri 64105",
  fpcOfficeDistance: "Serving all of Washington County and the Northeast Oklahoma region including Nowata, Osage, and surrounding Kansas border counties",
  serviceAreaIntro: "From the iconic Frank Lloyd Wright Price Tower piercing the downtown skyline to the sweeping prairies and bison herds of the Tallgrass Prairie Preserve, from the corporate campus of Phillips 66 to the historic Osage Nation community of Pawhuska and the Pioneer Woman Mercantile, from the oil heritage town of Dewey to the charming border communities of Copan and Caney — Fast Passport Center serves the entire Northeast Oklahoma and Kansas border region. We regularly help energy industry professionals, Osage County travelers, and local residents get their passports fast without the 310-mile drive to Dallas.",
  nearbyCitiesIntro: "We serve all Bartlesville neighborhoods and the surrounding Northeast Oklahoma area including Dewey, Copan, Nowata, Pawhuska, Owasso, and Claremore. If you are anywhere in Washington County, Osage County, or Nowata County, we have you covered.",
  howItWorksIntro: "Most Bartlesville travelers complete everything online and ship documents overnight. No need to drive to Dallas or wait in line at the regional agency.",
  mistakesIntro: "Bartlesville travelers often face a 5-hour drive to the nearest regional passport agency in Dallas. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Bartlesville energy professionals and Northeast Oklahoma travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Bartlesville? Here are the most common ones we hear from Washington County and Phillips 66 travelers.",
  statePageRoute: "/states/oklahoma",
  statePageName: "Oklahoma",
  dmvWebsite: "https://oklahoma.gov/dps.html",
  dmvLabel: "Oklahoma DPS — Driver License Services",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Bartlesville travelers with immediate departure needs — as fast as 24 hours for urgent international business or flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Bartlesville travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Bartlesville with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance for Bartlesville and Phillips 66 area residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "David H.",
      location: "Bartlesville, OK",
      rating: 5,
      text: "International assignment to Singapore came up with two weeks notice. Fast Passport Center got my passport in 36 hours. The Phillips 66 security team recommended them — now I know why.",
      service: "Emergency Passport",
    },
    {
      name: "Nancy P.",
      location: "Bartlesville, OK",
      rating: 5,
      text: "Our 40th anniversary trip to Italy. Fast Passport Center renewed both our passports in 3 days. From the Price Tower to the Leaning Tower — absolutely seamless!",
      service: "Passport Renewal",
    },
    {
      name: "Tom W.",
      location: "Pawhuska, OK",
      rating: 5,
      text: "Family trip to see the Northern Lights in Norway. Fast Passport Center handled all 6 passports in 4 days. Incredible for Osage County families. Couldn't be happier.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "bartlesville-ok-1",
      name: "Bartlesville Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "615 SW Jennings Ave",
      city: "Bartlesville",
      state: "OK",
      zip: "74003",
      phone: "(918) 336-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Bartlesville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Bartlesville facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "bartlesville-ok-2",
      name: "Washington County Court Clerk",
      type: "County Court Clerk Passport Acceptance",
      address: "420 S Johnstone Ave, Room 100",
      city: "Bartlesville",
      state: "OK",
      zip: "74003",
      phone: "(918) 337-2870",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Downtown Bartlesville Courthouse",
      website: "https://www.countycourthouse.org",
      websiteLabel: "Washington County Court Clerk",
      notes: "Accepts passport applications. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "bartlesville-ok-3",
      name: "Pawhuska Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 W Main St",
      city: "Pawhuska",
      state: "OK",
      zip: "74056",
      phone: "(918) 287-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles west of Bartlesville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Osage County and Tallgrass Prairie area. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "bartlesville-ok-4",
      name: "Nowata Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "109 N Maple St",
      city: "Nowata",
      state: "OK",
      zip: "74048",
      phone: "(918) 273-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles south of Bartlesville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Nowata County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "bartlesville-ok-5",
      name: "Owasso Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "12300 E 86th St N",
      city: "Owasso",
      state: "OK",
      zip: "74055",
      phone: "(918) 272-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "35 miles south of Bartlesville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves northern Tulsa metro. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5 hour drive to Dallas", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Bartlesville photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Washington County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Bartlesville applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Dallas regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Northeast Oklahoma families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Bartlesville travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Bartlesville." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Bartlesville address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Bartlesville before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Bartlesville for travelers with urgent international flights or business trips. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5-hour drive to Dallas." },
    { q: "How fast can I renew my passport in Bartlesville?", a: "Fast Passport Center offers fast passport renewal in Bartlesville in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Bartlesville?", a: "The nearest regional passport agency to Bartlesville is the Dallas Passport Agency, approximately 310 miles south via US-75. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Bartlesville without any in-person agency visit required." },
    { q: "Do you serve corporate travelers from Phillips 66?", a: "Absolutely. Fast Passport Center regularly serves Phillips 66 professionals and other Bartlesville corporate travelers. We understand short-notice international business travel and can process passports in 24–48 hours. Our courier service is trusted by energy industry professionals throughout Northeast Oklahoma." },
    { q: "Do you serve the entire Northeast Oklahoma region?", a: "Absolutely. Fast Passport Center serves the entire Northeast Oklahoma region including Bartlesville, Dewey, Copan, Nowata, Pawhuska, Owasso, and surrounding areas. Our courier service works seamlessly from any address in Washington County, Osage County, or Nowata County." },
    { q: "Can I expedite a child passport in Bartlesville?", a: "Yes. Fast Passport Center expedites child passports in Bartlesville for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Green Country families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Bartlesville with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Dallas Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Bartlesville", address: "4001 SE Green Country Rd, Bartlesville, OK 74006", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Bartlesville", address: "3810 SE Adams Rd, Bartlesville, OK 74006", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart Supercenter — Owasso", address: "12101 E 96th St N, Owasso, OK 74055", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "CVS Pharmacy — Claremore", address: "1000 W Will Rogers Blvd, Claremore, OK 74017", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
  ],
  dmvLocations: [
    {
      name: "Oklahoma DPS — Bartlesville",
      address: "401 SW Adams Blvd, Bartlesville, OK 74003",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Oklahoma DPS — Claremore",
      address: "200 S Missouri Ave, Claremore, OK 74017",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Rogers County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Oklahoma DPS — Owasso",
      address: "200 E 2nd Ave, Owasso, OK 74055",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves northern Tulsa metro. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "BVO",
      name: "Bartlesville Municipal Airport",
      distance: "3 miles west of downtown Bartlesville",
      address: "402 Airport Rd, Bartlesville, OK 74006",
      note: "Regional airport serving Bartlesville. About 8 minutes from downtown. General aviation and charter services.",
      flightUrl: "https://www.cityofbartlesville.org/airport",
      flightLabel: "BVO Airport",
      featured: true,
    },
    {
      code: "TUL",
      name: "Tulsa International Airport",
      distance: "50 miles south of Bartlesville",
      address: "7777 E Apache St, Tulsa, OK 74115",
      note: "Regional hub with direct flights to major cities. About 50 minutes from Bartlesville via US-75.",
      flightUrl: "https://www.tulsaairports.com/",
      flightLabel: "TUL Airport",
      featured: false,
    },
    {
      code: "ICT",
      name: "Wichita Dwight D. Eisenhower National Airport",
      distance: "130 miles northwest of Bartlesville",
      address: "2277 Eisenhower Airport Pkwy, Wichita, KS 67209",
      note: "Regional hub serving Kansas and northern Oklahoma. About 2 hours from Bartlesville.",
      flightUrl: "https://www.flywichita.com/",
      flightLabel: "ICT Airport",
      featured: false,
    },
  ],
};